import { useTeamContext } from '../context';
import { TeamContext } from '../context/types';

/** Full TeamContext value. Use when you need multiple fields or `reload`. */
export function useTeam(): TeamContext {
  return useTeamContext();
}
